import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

// icon
import { CiCalendar } from "react-icons/ci";
import { FiClock } from "react-icons/fi";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { FaCalendarAlt, FaMapMarkerAlt, FaUsers, FaTicketAlt, FaBuilding, FaAward, FaArrowRight, FaBookOpen, FaTimes, FaFilePdf, FaInstagram, FaExternalLinkAlt, FaChevronLeft, FaChevronRight, FaWhatsapp } from "react-icons/fa";

// images
import Newsimage1 from "./Images/newsbox image-1.svg";
import Newsimage2 from "./Images/newsbox image-2.svg";
import Newsimage3 from "./Images/newsbox image-3.svg";
import Whyjoinbg from "./Images/whyjoin-background.svg";
import ManImage from "./Images/whyjoinMan.svg";
import welcomeimage from "./Images/welocomeimage.svg";
import connectNowbg from "./Images/connectNowbg.svg";
import counterbg from "./Images/counterbg.svg";
import countericon1 from "./Images/countericon1.svg";
import countericon2 from "./Images/countericon2.svg";
import countericon3 from "./Images/countericon3.svg";
import countericon4 from "./Images/countericon4.svg";

import Sticky from "../../stickySide/Sticky";
import { motion } from "framer-motion";
import Teams from "./Teams";
import Birthday from "./Birthday";
import Getintouch from "./Getintouch";
import Sliders from "./Banner SLider/Sliders";

import { blogs } from "../../Blogs copy/BlogData";
import BlogList from "../../Blogs copy/BlogList";
import Testomonail from "./Testomonial/Testomonail";
import axios from "axios";

interface gallerydata {
  id: number;
  image: string;
}

const Homes = () => {
  const navigate = useNavigate();
  const [galleryimagedata, setGalleryImagedata] = useState<gallerydata[]>([]);
  const [leaderboard, setLeaderboard] = useState<any[]>([]);
  const [upcomingEvents, setUpcomingEvents] = useState<any[]>([]);
  const [newsHeading, setNewsHeading] = useState<string>('');
  const [selectedEventModal, setSelectedEventModal] = useState<any | null>(null);
  const [activeEvtPhotoIndex, setActiveEvtPhotoIndex] = useState<number>(0);
  const leaderSliderRef = useRef<HTMLDivElement>(null);

  const [newsMediaList, setNewsMediaList] = useState<any[]>([]);
  const [featuredVideo, setFeaturedVideo] = useState<{ title?: string; video_url?: string; description?: string } | null>(null);
  const [selectedNewsArticle, setSelectedNewsArticle] = useState<any | null>(null);

  const [isMemberLoggedIn, setIsMemberLoggedIn] = useState<boolean>(false);
  const [rmbiansOfMeetingList, setRmbiansOfMeetingList] = useState<any[]>([]);
  const [currentRmbianIndex, setCurrentRmbianIndex] = useState<number>(0);
  const [todayBirthdayMember, setTodayBirthdayMember] = useState<any | null>(null);
  const [showBirthdayModal, setShowBirthdayModal] = useState<boolean>(false);

  useEffect(() => {
    // Check member login status
    axios.get("https://rmbbackend.rmbjaipur.com/auth/memberLoggedIn", { withCredentials: true })
      .then(res => {
        if (res.data?.loggedIn || res.data?.user || res.data?.data) {
          setIsMemberLoggedIn(true);
        } else {
          const userStr = localStorage.getItem('user') || localStorage.getItem('impersonatedUser');
          if (userStr) setIsMemberLoggedIn(true);
        }
      })
      .catch(() => {
        const userStr = localStorage.getItem('user') || localStorage.getItem('impersonatedUser');
        if (userStr) setIsMemberLoggedIn(true);
      });

    axios.get("https://rmbbackend.rmbjaipur.com/auth/newsheading")
      .then(res => {
        if (res.data?.data?.[0]?.title) {
          setNewsHeading(res.data.data[0].title);
        }
      })
      .catch(err => console.error("Error fetching news heading:", err));

    axios.get("https://rmbbackend.rmbjaipur.com/auth/news-media")
      .then(res => setNewsMediaList(res.data.data || []))
      .catch(err => console.error("Error fetching news media:", err));

    axios.get("https://rmbbackend.rmbjaipur.com/auth/featured-video")
      .then(res => setFeaturedVideo(res.data.data || null))
      .catch(err => console.error("Error fetching featured video:", err));

    axios.get("https://rmbbackend.rmbjaipur.com/auth/rmbians-of-meeting")
      .then(res => {
        if (res.data?.data && Array.isArray(res.data.data)) {
          setRmbiansOfMeetingList(res.data.data);
        }
      })
      .catch(err => console.error("Error fetching rmbians of meeting:", err));
  }, []);

  const handleLeaderScroll = (direction: 'left' | 'right') => {
    if (leaderSliderRef.current) {
      const scrollAmount = direction === 'left' ? -250 : 250;
      leaderSliderRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const handlePrevRmbian = () => {
    setCurrentRmbianIndex(prev => (prev === 0 ? (rmbiansOfMeetingList.length ? rmbiansOfMeetingList.length - 1 : 0) : prev - 1));
  };

  const handleNextRmbian = () => {
    setCurrentRmbianIndex(prev => (prev === (rmbiansOfMeetingList.length ? rmbiansOfMeetingList.length - 1 : 0) ? 0 : prev + 1));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<gallerydata[]>(
          "https://rmbbackend.rmbjaipur.com/auth/gallery"
        );
        setGalleryImagedata(response.data);
      } catch (error) {
        console.error("gallery Not Found:", error);
      }
    };

    const fetchLeaderboardAndBirthdays = async () => {
      try {
        const response = await axios.get("https://rmbbackend.rmbjaipur.com/auth/allusersinfo");
        const users: any[] = Array.isArray(response.data) ? response.data : [];
        const activeUsers = users.filter((u: any) => u.role !== 'super-admin' && u.delete !== 1 && u.name && u.name.trim().toLowerCase() !== 'admin');

        const sorted = [...activeUsers].sort((a: any, b: any) => (b.point || 0) - (a.point || 0)).slice(0, 10);
        setLeaderboard(sorted);

        // Check if any member has birthday today matching current date strictly
        const exactMatch = activeUsers.find((u: any) => {
          const dobStr = u.dob || u.DOB;
          if (!dobStr) return false;
          const parts = dobStr.split('T')[0].split('-');
          const today = new Date();
          if (parts.length === 3) {
            return parseInt(parts[1], 10) === (today.getMonth() + 1) && parseInt(parts[2], 10) === today.getDate();
          }
          const d = new Date(dobStr);
          return !isNaN(d.getTime()) && d.getMonth() === today.getMonth() && d.getDate() === today.getDate();
        });

        if (exactMatch && !sessionStorage.getItem('birthdayModalDismissed')) {
          setTodayBirthdayMember(exactMatch);
          setShowBirthdayModal(true);
        } else {
          setTodayBirthdayMember(null);
          setShowBirthdayModal(false);
        }
      } catch (error) {
        console.error("Leaderboard & Birthday fetch error:", error);
      }
    };

    const fetchEvents = async () => {
      try {
        const res = await axios.get<any[]>("https://rmbbackend.rmbjaipur.com/auth/events");
        const list = Array.isArray(res.data) ? res.data : [];

        const now = new Date();
        now.setHours(0, 0, 0, 0); // Start of today

        // Filter events strictly where date is GREATER THAN OR EQUAL TO current date (Upcoming Events Only)
        const upcoming = list.filter((e: any) => {
          let eDateStr = e.event_date || e.start_date;
          if (!eDateStr) return false;
          if (typeof eDateStr === 'string' && eDateStr.includes(' ') && !eDateStr.includes('T')) {
            eDateStr = eDateStr.replace(' ', 'T');
          }
          const eDate = new Date(eDateStr);
          return !isNaN(eDate.getTime()) && eDate >= now;
        });

        // Sort by date ascending (soonest upcoming event first)
        upcoming.sort((a: any, b: any) => {
          let aStr = a.event_date || a.start_date || '';
          let bStr = b.event_date || b.start_date || '';
          if (typeof aStr === 'string' && aStr.includes(' ') && !aStr.includes('T')) aStr = aStr.replace(' ', 'T');
          if (typeof bStr === 'string' && bStr.includes(' ') && !bStr.includes('T')) bStr = bStr.replace(' ', 'T');
          return new Date(aStr).getTime() - new Date(bStr).getTime();
        });

        // Limit to maximum 3 upcoming events at a time on home page
        setUpcomingEvents(upcoming.slice(0, 3));
      } catch (err) {
        console.error("Error fetching events for homepage:", err);
      }
    };

    fetchData();
    fetchLeaderboardAndBirthdays();
    fetchEvents();
  }, []);

  // Auto-scroller for Point Table Leaders (Scrolls every 3 seconds)
  useEffect(() => {
    const autoScrollInterval = setInterval(() => {
      if (leaderSliderRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = leaderSliderRef.current;
        if (scrollLeft + clientWidth >= scrollWidth - 15) {
          leaderSliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          leaderSliderRef.current.scrollBy({ left: 240, behavior: 'smooth' });
        }
      }
    }, 3000);

    return () => clearInterval(autoScrollInterval);
  }, [leaderboard]);

  return (
    <div className="bg-[#0A111E] text-slate-100 font-sans min-h-screen">
      <Header />
      <Sticky />

      {/* 1. HERO SLIDER */}
      <Sliders />

      {/* 2. ANNOUNCEMENT TEXT NEWS TICKER (Scrolling Marquee) */}
      {newsHeading && (
        <div className="bg-gradient-to-r from-[#131E32] via-[#0A2451] to-[#131E32] border-b-2 border-[#FDBC12] px-[5%] py-3.5 shadow-xl">
          <div className="max-w-7xl mx-auto flex items-center gap-3">
            <div className="bg-[#FDBC12] text-[#0A2451] font-black text-xs uppercase px-3 py-1 rounded-xl shadow-md flex items-center gap-1.5 flex-shrink-0 z-10">
              <span>📢</span>
              <span>TEXT NEWS</span>
            </div>
            <div className="overflow-hidden w-full relative whitespace-nowrap">
              <div 
                className="inline-block text-sm md:text-base font-bold text-amber-300 tracking-wide cursor-pointer hover:[animation-play-state:paused]"
                style={{
                  display: 'inline-block',
                  whiteSpace: 'nowrap',
                  animation: 'marqueeScroll 25s linear infinite'
                }}
              >
                <span>{newsHeading}</span>
              </div>
              <style>{`
                @keyframes marqueeScroll {
                  0% { transform: translateX(100%); }
                  100% { transform: translateX(-100%); }
                }
              `}</style>
            </div>
          </div>
        </div>
      )}

      {/* 3. TOP RMBIANS OF THE MONTH SCROLLER (Standard Homepage Width) */}
      {leaderboard.length > 0 && (
        <div className="bg-[#0B1120] py-16 px-[8%] border-b border-[#1E293B] shadow-2xl">
          <div className="max-w-7xl mx-auto space-y-8">
            {/* Header with Navigation Controls */}
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              <div className="text-center sm:text-left space-y-1">
                <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-wide">
                  Top <span className="text-[#FDBC12]">RMBians</span> of the Month
                </h2>
                <p className="text-slate-400 text-sm font-medium">
                  Celebrating the most active contributors in the community.
                </p>
              </div>

              {/* Scroll Navigation Arrows */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleLeaderScroll('left')}
                  className="w-10 h-10 rounded-full bg-[#10192D] border border-slate-700 hover:border-[#FDBC12] text-[#FDBC12] flex items-center justify-center transition shadow cursor-pointer"
                  title="Previous"
                >
                  <RiArrowLeftSLine size={22} />
                </button>
                <button
                  onClick={() => handleLeaderScroll('right')}
                  className="w-10 h-10 rounded-full bg-[#10192D] border border-slate-700 hover:border-[#FDBC12] text-[#FDBC12] flex items-center justify-center transition shadow cursor-pointer"
                  title="Next"
                >
                  <RiArrowRightSLine size={22} />
                </button>
              </div>
            </div>

            {/* Interactive Horizontal Slider Track - Smooth Auto & Arrow Slider */}
            <div className="relative overflow-hidden">
              <div
                ref={leaderSliderRef}
                className="flex items-stretch gap-4 sm:gap-5 overflow-x-auto py-4 px-1 scroll-smooth no-scrollbar snap-x snap-mandatory"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
              >
                {leaderboard.map((user: any, idx: number) => {
                  const rankNumber = `#${idx + 1}`;
                  let rankBg = 'bg-[#FDBC12] text-black';
                  if (idx === 1) rankBg = 'bg-[#94A3B8] text-black';
                  if (idx === 2) rankBg = 'bg-[#F97316] text-black';

                  return (
                    <div
                      key={user.id}
                      className="relative bg-[#10192D] border border-slate-800/80 rounded-2xl p-5 w-[80vw] sm:w-[240px] md:w-[230px] lg:w-[calc((100%-4*1.25rem)/5)] h-[350px] flex flex-col items-center justify-between shadow-xl flex-shrink-0 snap-start hover:border-[#FDBC12] hover:-translate-y-1 transition-all duration-300"
                    >
                      {/* Top Left Rank Badge */}
                      <div className={`absolute top-3.5 left-3.5 ${rankBg} font-black text-xs px-2.5 py-0.5 rounded-lg shadow-md z-10`}>
                        {rankNumber}
                      </div>

                      {/* Circular Avatar Frame - Uncut Image Display */}
                      <div className="w-22 h-22 sm:w-24 sm:h-24 rounded-full border-2 border-[#FDBC12] p-0.5 overflow-hidden bg-[#0A1527] mt-2 mb-1 shadow-lg flex-shrink-0 flex items-center justify-center">
                        <img
                          src={user.profile ? (user.profile.startsWith('http') ? user.profile : `https://rmbbackend.rmbjaipur.com/${user.profile.replace(/\\/g, '/')}`) : 'https://via.placeholder.com/120?text=Member'}
                          alt={user.name}
                          className="w-full h-full object-contain rounded-full bg-[#0A1527]"
                          onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/120?text=Member'; }}
                        />
                      </div>

                      {/* Name & Role & Category */}
                      <div className="text-center space-y-1 w-full flex-1 flex flex-col justify-center my-1">
                        <h4 className="text-white font-bold text-sm sm:text-base line-clamp-1">{user.name}</h4>
                        <p className="text-[#FDBC12] text-xs font-semibold">
                          {user.designation || (user.role === 'admin' ? 'Leader' : 'Member')}
                        </p>
                        <p className="text-slate-400 text-xs line-clamp-2 leading-snug px-1">
                          {user.company_name || 'RMB Jaipur Member'}
                        </p>
                      </div>

                      {/* Points Pill at Bottom */}
                      <div className="text-[#FDBC12] font-bold text-xs flex items-center justify-center gap-1.5 pt-2.5 border-t border-slate-800/80 w-full mt-auto">
                        <span>✪</span>
                        <span>{user.point || 0} Points</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* UPCOMING GENERAL MEETINGS & CHAPTER EVENTS SECTION */}
      <div className="bg-[#0D1829] py-16 px-[8%] border-b border-[#465468]/60 shadow-2xl">
        <div className="max-w-7xl mx-auto space-y-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
            <div>
              <div className="inline-block bg-[#FDBC12]/15 text-[#FDBC12] text-xs font-black uppercase px-3 py-1 rounded-full border border-[#FDBC12]/30 mb-2 tracking-wider">
                🗓️ Chapter Meetings & Calendar
              </div>
              <h2 className="text-[32px] md:text-[40px] text-[#F1F4F9] font-black tracking-wide leading-tight">
                Upcoming <span className="text-[#FDBC12]">General Meetings & Events</span>
              </h2>
              <p className="text-xs md:text-sm text-[#94A2B8] mt-1 font-semibold">
                Join our fellowship meetings, business presentations, and networking field visits.
              </p>
            </div>

            <Link to="/meetings">
              <button className="bg-[#02256D] hover:bg-blue-900 text-[#FDBC12] px-5 py-2.5 rounded-xl font-bold text-xs border border-[#FDBC12]/40 shadow-lg flex items-center gap-2 transition cursor-pointer">
                View All Meetings <FaArrowRight />
              </button>
            </Link>
          </div>

          {upcomingEvents.length === 0 ? (
            <div className="bg-[#131E32] p-8 rounded-2xl border border-[#2A3B5C] text-center space-y-2 max-w-5xl mx-auto">
              <FaCalendarAlt className="text-4xl text-[#FDBC12] mx-auto opacity-70" />
              <h3 className="text-base font-bold text-white">General Meeting 123 & Chapter Schedule</h3>
              <p className="text-xs text-slate-400">Regular Chapter Meetings are held on bi-weekly Thursdays. Check back shortly for updated details.</p>
            </div>
          ) : upcomingEvents.length === 1 ? (
            /* FEATURED FULL-WIDTH BANNER WHEN ONLY 1 UPCOMING EVENT EXISTS */
            (() => {
              const evt = upcomingEvents[0];
              let photo = 'uploads/default_news.jpg';
              let galleryPhotos: string[] = [];
              const rawPhotos = evt.photographs || evt.photos || evt.gallery || evt.img || evt.image;
              if (rawPhotos) {
                try {
                  const parsed = typeof rawPhotos === 'string' ? JSON.parse(rawPhotos) : rawPhotos;
                  if (Array.isArray(parsed) && parsed.length > 0) galleryPhotos = parsed;
                  else if (typeof rawPhotos === 'string' && rawPhotos.includes('&')) galleryPhotos = rawPhotos.split('&').filter(Boolean);
                  else if (typeof rawPhotos === 'string' && rawPhotos.trim() !== '') galleryPhotos = [rawPhotos];
                } catch {
                  if (typeof rawPhotos === 'string' && rawPhotos.includes('&')) galleryPhotos = rawPhotos.split('&').filter(Boolean);
                  else if (typeof rawPhotos === 'string' && rawPhotos.trim() !== '') galleryPhotos = [rawPhotos];
                }
              }
              const allEvtPhotos = galleryPhotos.map((p: string) => p.startsWith('http') ? p : `https://rmbbackend.rmbjaipur.com/${p.replace(/\\/g, '/').replace(/^\/+/, '')}`);
              if (allEvtPhotos.length === 0) allEvtPhotos.push('https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg');

              return (
                <div className="w-full max-w-5xl mx-auto bg-gradient-to-r from-[#131E32] via-[#0A1D3A] to-[#131E32] border-2 border-[#FDBC12] rounded-3xl p-6 md:p-8 shadow-2xl transition-all duration-300">
                  <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
                    {/* Left Column: Cover Photo */}
                    <div 
                      className="md:col-span-5 h-64 md:h-72 rounded-2xl overflow-hidden bg-slate-950 border border-[#2A3B5C] cursor-pointer relative shadow-xl group flex items-center justify-center"
                      onClick={() => { setSelectedEventModal({ ...evt, allPhotos: allEvtPhotos }); setActiveEvtPhotoIndex(0); }}
                    >
                      <img
                        src={allEvtPhotos[0] || 'https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg'}
                        alt={evt.heading || evt.description || 'Event Photo'}
                        className="w-full h-full object-contain max-h-72 mx-auto group-hover:scale-105 transition duration-500"
                        onError={(e) => { e.currentTarget.src = 'https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg'; }}
                      />
                      <div className="absolute top-3 left-3 bg-[#0A2451] text-[#FDBC12] border border-[#FDBC12]/60 text-xs font-black uppercase px-3 py-1 rounded-full shadow-lg">
                        ✨ Upcoming Chapter Event
                      </div>
                    </div>

                    {/* Right Column: Event Details & Action Buttons */}
                    <div className="md:col-span-7 space-y-4">
                      <div className="flex flex-wrap justify-between items-center gap-2">
                        <span className="bg-[#0A2451] text-[#FDBC12] border border-[#FDBC12]/40 text-xs font-extrabold uppercase px-3 py-1 rounded-full">
                          {evt.event_type || 'General Meeting'}
                        </span>
                        <span className="text-xs text-amber-300 font-bold flex items-center gap-1.5 bg-[#1E2B45] px-3 py-1 rounded-full border border-white/10">
                          <CiCalendar className="text-[#FDBC12] text-base" />
                          {evt.event_date ? new Date(evt.event_date).toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'Upcoming Event'}
                        </span>
                      </div>

                      <h3 
                        className="text-2xl md:text-3xl font-black text-white leading-tight cursor-pointer hover:text-[#FDBC12] transition"
                        onClick={() => { setSelectedEventModal({ ...evt, allPhotos: allEvtPhotos }); setActiveEvtPhotoIndex(0); }}
                      >
                        {evt.heading || evt.description || evt.location || `General Meeting #${evt.id}`}
                      </h3>

                      {(evt.location || evt.venue) && (
                        <p className="text-sm text-slate-300 font-semibold flex items-center gap-2">
                          <FaMapMarkerAlt className="text-rose-400 text-base flex-shrink-0" />
                          <span>{evt.location || evt.venue}</span>
                        </p>
                      )}

                      {evt.presentation_1 && evt.event_type !== 'Social' && (
                        <div className="bg-[#1E2B45] p-3.5 rounded-2xl border border-white/10 space-y-1 text-xs">
                          <p className="font-bold text-amber-300 text-xs">
                            {evt.event_type === 'Installation'
                              ? '👑 Chief Guest:'
                              : evt.event_type === 'Webinar'
                              ? '🎙️ Keynote Speaker:'
                              : evt.event_type === 'Field Visit'
                              ? '📍 Field Visit Host Member:'
                              : '💼 Business Presentation:'}
                          </p>
                          <p className="text-slate-100 font-bold text-sm">{evt.presentation_1}</p>
                          {evt.presentation_2 && (
                            <p className="text-emerald-400 font-semibold text-xs pt-0.5">
                              {evt.event_type === 'Installation'
                                ? `🏢 ${evt.presentation_2}`
                                : evt.event_type === 'Webinar'
                                ? `🏢 ${evt.presentation_2}`
                                : evt.event_type === 'Field Visit'
                                ? `🏢 Business: ${evt.presentation_2}`
                                : `🎤 ${evt.presentation_2}`}
                            </p>
                          )}
                        </div>
                      )}

                      <div className="pt-2 flex flex-wrap items-center gap-3">
                        <button
                          onClick={() => { setSelectedEventModal({ ...evt, allPhotos: allEvtPhotos }); setActiveEvtPhotoIndex(0); }}
                          className="px-4 py-2.5 bg-[#465468] hover:bg-[#FDBC12] hover:text-[#0A2451] text-slate-200 text-xs font-bold rounded-xl border border-[#64748B] transition flex items-center gap-2 cursor-pointer shadow-md"
                        >
                          <FaBookOpen /> Highlights & Details
                        </button>

                        <a
                          href={(() => {
                            const title = encodeURIComponent(evt.heading || evt.description || evt.location || 'RMB General Meeting');
                            const details = encodeURIComponent(evt.description || 'Rotary Means Business Chapter Meeting & Networking.');
                            const location = encodeURIComponent(evt.location || evt.venue || 'Jaipur');
                            const rawDate = evt.event_date || evt.start_date;
                            const start = rawDate ? new Date(rawDate) : new Date();
                            const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
                            const fmtIso = (d: Date) => d.toISOString().replace(/-|:|\.\d\d\d/g, '');
                            return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}&location=${location}&dates=${fmtIso(start)}/${fmtIso(end)}`;
                          })()}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-4 py-2.5 bg-[#02256D] hover:bg-blue-900 text-[#FDBC12] text-xs font-bold rounded-xl border border-[#FDBC12]/40 shadow-lg flex items-center gap-2 transition cursor-pointer"
                        >
                          <FaCalendarAlt /> Sync Calendar
                        </a>

                        <button
                          onClick={() => {
                            navigate(`/event-rsvp/cal_${evt.id}`);
                          }}
                          className="px-4 py-2.5 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] text-xs font-black rounded-xl transition flex items-center gap-2 cursor-pointer shadow-md"
                        >
                          <FaTicketAlt /> Attend Event
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()
          ) : (
            <div className={`grid grid-cols-1 ${upcomingEvents.length === 2 ? 'md:grid-cols-2 max-w-5xl mx-auto' : 'md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto'} gap-6`}>
              {upcomingEvents.map((evt: any) => {
                let photo = 'uploads/default_news.jpg';
                let galleryPhotos: string[] = [];
                const rawPhotos = evt.photographs || evt.photos || evt.gallery || evt.img || evt.image;
                if (rawPhotos) {
                  try {
                    const parsed = typeof rawPhotos === 'string' ? JSON.parse(rawPhotos) : rawPhotos;
                    if (Array.isArray(parsed) && parsed.length > 0) {
                      photo = parsed[0];
                      galleryPhotos = parsed;
                    } else if (typeof rawPhotos === 'string' && rawPhotos.includes('&')) {
                      galleryPhotos = rawPhotos.split('&').filter(Boolean);
                      photo = galleryPhotos[0] || rawPhotos;
                    } else if (typeof rawPhotos === 'string') {
                      photo = rawPhotos;
                      galleryPhotos = [rawPhotos];
                    }
                  } catch {
                    if (typeof rawPhotos === 'string' && rawPhotos.includes('&')) {
                      galleryPhotos = rawPhotos.split('&').filter(Boolean);
                      photo = galleryPhotos[0] || rawPhotos;
                    } else {
                      photo = rawPhotos;
                      galleryPhotos = [rawPhotos];
                    }
                  }
                }

                const allEvtPhotos = galleryPhotos.map((p: string) => p.startsWith('http') ? p : `https://rmbbackend.rmbjaipur.com/${p.replace(/\\/g, '/').replace(/^\/+/, '')}`);
                if (allEvtPhotos.length === 0) {
                  allEvtPhotos.push('https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg');
                }

                return (
                  <div key={evt.id} className="bg-[#131E32] border border-[#2A3B5C] hover:border-[#FDBC12] rounded-2xl p-5 shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col justify-between space-y-4">
                    <div className="space-y-3">
                      <div className="flex justify-between items-center">
                        <span className="bg-[#0A2451] text-[#FDBC12] border border-[#FDBC12]/40 text-[10px] font-extrabold uppercase px-2.5 py-1 rounded-full">
                          {evt.event_type || 'General Meeting'}
                        </span>
                        <span className="text-[11px] text-slate-400 font-bold flex items-center gap-1">
                          <CiCalendar className="text-[#FDBC12] text-sm" />
                          {evt.event_date ? new Date(evt.event_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Upcoming'}
                        </span>
                      </div>

                      <div 
                        className="w-full h-48 rounded-xl overflow-hidden bg-slate-950 border border-[#2A3B5C] cursor-pointer flex items-center justify-center"
                        onClick={() => { setSelectedEventModal({ ...evt, allPhotos: allEvtPhotos }); setActiveEvtPhotoIndex(0); }}
                      >
                        <img
                          src={allEvtPhotos[0] || 'https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg'}
                          alt={evt.heading || evt.description || 'Event Photo'}
                          className="w-full h-full object-contain max-h-48 mx-auto hover:scale-105 transition duration-500"
                          onError={(e) => { e.currentTarget.src = 'https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg'; }}
                        />
                      </div>

                      <h3 
                        className="text-lg font-black text-white leading-snug line-clamp-2 cursor-pointer hover:text-[#FDBC12] transition"
                        onClick={() => { setSelectedEventModal({ ...evt, allPhotos: allEvtPhotos }); setActiveEvtPhotoIndex(0); }}
                      >
                        {evt.heading || evt.description || evt.location || `General Meeting #${evt.id}`}
                      </h3>

                      {(evt.location || evt.venue) && (
                        <p className="text-xs text-slate-300 font-medium flex items-center gap-1.5">
                          <FaMapMarkerAlt className="text-rose-400 flex-shrink-0" />
                          <span className="line-clamp-1">{evt.location || evt.venue}</span>
                        </p>
                      )}

                      {evt.presentation_1 && evt.event_type !== 'Social' && (
                        <div className="bg-[#1E2B45] p-2.5 rounded-xl border border-white/5 space-y-1 text-xs">
                          <p className="font-bold text-amber-300 text-[11px]">
                            {evt.event_type === 'Installation'
                              ? '👑 Chief Guest:'
                              : evt.event_type === 'Webinar'
                              ? '🎙️ Keynote Speaker:'
                              : evt.event_type === 'Field Visit'
                              ? '📍 Field Visit Host Member:'
                              : '💼 Business Presentation:'}
                          </p>
                          <p className="text-slate-200 font-semibold text-[11px]">{evt.presentation_1}</p>
                          {evt.presentation_2 && (
                            <p className="text-emerald-400 font-semibold text-[11px]">
                              {evt.event_type === 'Installation'
                                ? `🏢 ${evt.presentation_2}`
                                : evt.event_type === 'Webinar'
                                ? `🏢 ${evt.presentation_2}`
                                : evt.event_type === 'Field Visit'
                                ? `🏢 Business: ${evt.presentation_2}`
                                : `🎤 ${evt.presentation_2}`}
                            </p>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="pt-3 border-t border-[#2A3B5C] flex flex-wrap items-center justify-between gap-2">
                      <button
                        onClick={() => { setSelectedEventModal({ ...evt, allPhotos: allEvtPhotos }); setActiveEvtPhotoIndex(0); }}
                        className="px-2.5 py-1.5 bg-[#465468] hover:bg-[#FDBC12] hover:text-[#0A2451] text-slate-200 text-xs font-bold rounded-lg border border-[#64748B] transition flex items-center gap-1 cursor-pointer"
                      >
                        <FaBookOpen /> Highlights
                      </button>

                      <a
                        href={(() => {
                          const title = encodeURIComponent(evt.heading || evt.description || evt.location || 'RMB General Meeting');
                          const details = encodeURIComponent(evt.description || 'Rotary Means Business Chapter Meeting & Networking.');
                          const location = encodeURIComponent(evt.location || evt.venue || 'Jaipur');
                          const rawDate = evt.event_date || evt.start_date;
                          const start = rawDate ? new Date(rawDate) : new Date();
                          const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
                          const fmtIso = (d: Date) => d.toISOString().replace(/-|:|\.\d\d\d/g, '');
                          return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}&location=${location}&dates=${fmtIso(start)}/${fmtIso(end)}`;
                        })()}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-2.5 py-1.5 bg-[#02256D] hover:bg-blue-900 text-[#FDBC12] text-xs font-bold rounded-lg border border-[#FDBC12]/30 transition flex items-center gap-1 cursor-pointer"
                        title="Sync with Google Calendar"
                      >
                        <FaCalendarAlt /> Sync Calendar
                      </a>

                      <button
                        onClick={() => {
                          navigate(`/event-rsvp/cal_${evt.id}`);
                        }}
                        className="px-2.5 py-1.5 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] text-xs font-extrabold rounded-lg transition flex items-center gap-1 cursor-pointer"
                      >
                        <FaTicketAlt /> Attend
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* FULL UNCROPPED PHOTO GALLERY & EMBEDDED MoM PDF MODAL FOR UPCOMING EVENTS */}
      {selectedEventModal && (
        <div className="fixed inset-0 z-50 bg-black/85 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-[#1E2B45] border border-[#2A3B5C] rounded-2xl max-w-3xl w-full max-h-[92vh] overflow-y-auto p-6 text-slate-100 shadow-2xl space-y-4">
            
            {/* Header */}
            <div className="flex justify-between items-start border-b border-[#2A3B5C] pb-3">
              <div>
                <span className="bg-[#FDBC12] text-[#0A2451] text-[10px] font-black uppercase px-2.5 py-0.5 rounded-full">
                  🗓️ Chapter Event Details & MoM
                </span>
                <h2 className="text-xl font-black text-white mt-1 leading-snug">{selectedEventModal.heading || selectedEventModal.description || 'General Meeting'}</h2>
                <p className="text-xs text-slate-400 flex items-center gap-2 mt-1 font-semibold">
                  <FaCalendarAlt className="text-[#FDBC12]" /> 
                  {selectedEventModal.event_date ? new Date(selectedEventModal.event_date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }) : 'Upcoming Chapter Event'}
                </p>
              </div>
              <button 
                onClick={() => setSelectedEventModal(null)}
                className="p-2 text-slate-400 hover:text-white rounded-xl hover:bg-slate-800 font-bold transition cursor-pointer"
              >
                <FaTimes size={20} />
              </button>
            </div>

            {/* UNCROPPED FULL PHOTO DISPLAY */}
            {selectedEventModal.allPhotos && selectedEventModal.allPhotos.length > 0 && (
              <div className="w-full bg-[#0A111E] rounded-2xl border border-[#2A3B5C] p-3 relative flex items-center justify-center min-h-[300px] max-h-[460px] overflow-hidden group shadow-2xl">
                <img
                  src={selectedEventModal.allPhotos[activeEvtPhotoIndex] || 'https://via.placeholder.com/600x400?text=RMB+Event'}
                  alt={selectedEventModal.heading || 'Event Photo'}
                  className="max-h-[440px] w-auto max-w-full object-contain mx-auto transition-all duration-300 shadow-2xl rounded-xl"
                />

                {selectedEventModal.allPhotos.length > 1 && (
                  <>
                    <button
                      onClick={() => setActiveEvtPhotoIndex((prev) => (prev === 0 ? selectedEventModal.allPhotos.length - 1 : prev - 1))}
                      className="absolute left-3 w-10 h-10 rounded-full bg-black/70 hover:bg-[#FDBC12] text-white hover:text-[#0A2451] flex items-center justify-center font-bold text-xl border border-white/20 transition shadow-2xl cursor-pointer opacity-80 hover:opacity-100"
                    >
                      <FaChevronLeft size={16} />
                    </button>
                    <button
                      onClick={() => setActiveEvtPhotoIndex((prev) => (prev === selectedEventModal.allPhotos.length - 1 ? 0 : prev + 1))}
                      className="absolute right-3 w-10 h-10 rounded-full bg-black/70 hover:bg-[#FDBC12] text-white hover:text-[#0A2451] flex items-center justify-center font-bold text-xl border border-white/20 transition shadow-2xl cursor-pointer opacity-80 hover:opacity-100"
                    >
                      <FaChevronRight size={16} />
                    </button>

                    <div className="absolute bottom-4 right-4 bg-black/80 text-[#FDBC12] text-xs font-black px-3 py-1 rounded-full border border-[#FDBC12]/40 shadow-lg">
                      {activeEvtPhotoIndex + 1} / {selectedEventModal.allPhotos.length}
                    </div>
                  </>
                )}
              </div>
            )}

            {/* RELATED PHOTOGRAPHS THUMBNAIL RIBBON */}
            {selectedEventModal.allPhotos && selectedEventModal.allPhotos.length > 1 && (
              <div className="space-y-1.5 bg-[#131E32] p-3 rounded-xl border border-[#2A3B5C]">
                <span className="text-[11px] font-bold text-[#FDBC12] uppercase tracking-wider block">
                  📷 Event Photo Gallery ({selectedEventModal.allPhotos.length} Photos Uploaded by Admin):
                </span>
                <div className="flex gap-2.5 overflow-x-auto py-1 px-0.5 no-scrollbar scroll-smooth">
                  {selectedEventModal.allPhotos.map((photoUrl: string, idx: number) => (
                    <button
                      key={idx}
                      onClick={() => setActiveEvtPhotoIndex(idx)}
                      className={`w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 border-2 transition-all cursor-pointer ${
                        activeEvtPhotoIndex === idx
                          ? 'border-[#FDBC12] scale-105 shadow-xl ring-2 ring-[#FDBC12]/50'
                          : 'border-[#2A3B5C] opacity-60 hover:opacity-100 hover:border-slate-300'
                      }`}
                    >
                      <img src={photoUrl} alt={`Event photo ${idx + 1}`} className="w-full h-full object-cover" />
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Content Details */}
            <div className="bg-[#131E32] p-4 rounded-xl border border-[#2A3B5C] space-y-3 text-xs">
              <h4 className="font-bold text-[#FDBC12] uppercase text-[11px] tracking-wider">📝 Event Agenda & Description</h4>
              <p className="text-slate-200 leading-relaxed font-medium whitespace-pre-line text-xs">
                {selectedEventModal.description || selectedEventModal.content || 'Regular Chapter Meeting & Networking Event.'}
              </p>
            </div>

            {/* Presentations & Location info */}
            {selectedEventModal.presentation_1 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs">
                <div className="bg-[#131E32] p-3 rounded-xl border border-emerald-500/30">
                  <span className="text-emerald-400 font-bold block mb-1">💼 Business Presentation 1:</span>
                  <p className="text-white font-semibold">{selectedEventModal.presentation_1}</p>
                </div>
                {selectedEventModal.presentation_2 && (
                  <div className="bg-[#131E32] p-3 rounded-xl border border-purple-500/30">
                    <span className="text-purple-400 font-bold block mb-1">🎓 Presentation 2 / Education:</span>
                    <p className="text-white font-semibold">{selectedEventModal.presentation_2}</p>
                  </div>
                )}
              </div>
            )}

            {/* EMBEDDED MINUTES OF MEETING (MoM) PDF VIEWER */}
            {selectedEventModal.mom_pdf && (
              <div className="bg-[#131E32] p-4 rounded-xl border border-[#2A3B5C] space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-[11px] font-bold text-[#FDBC12] uppercase tracking-wider flex items-center gap-1.5">
                    <FaFilePdf className="text-red-400 text-sm animate-pulse" /> Official Minutes of Meeting (MoM) PDF Document:
                  </span>
                  <a
                    href={`https://rmbbackend.rmbjaipur.com/${selectedEventModal.mom_pdf.replace(/\\/g, '/')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[11px] font-bold text-amber-300 hover:text-white flex items-center gap-1 underline"
                  >
                    Open Full Screen <FaExternalLinkAlt size={10} />
                  </a>
                </div>

                <div className="w-full h-[400px] rounded-xl overflow-hidden border border-[#2A3B5C] bg-slate-900 shadow-inner">
                  <iframe
                    src={`https://rmbbackend.rmbjaipur.com/${selectedEventModal.mom_pdf.replace(/\\/g, '/')}`}
                    title="Minutes of Meeting PDF Document"
                    className="w-full h-full border-0"
                  />
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-wrap items-center justify-between gap-3 border-t border-[#2A3B5C] pt-4">
              {selectedEventModal.mom_pdf ? (
                <a
                  href={`https://rmbbackend.rmbjaipur.com/${selectedEventModal.mom_pdf.replace(/\\/g, '/')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-2.5 bg-[#02256D] hover:bg-blue-900 text-white font-bold text-xs rounded-xl shadow-lg border border-[#FDBC12]/40 flex items-center gap-2 transition"
                >
                  <FaFilePdf className="text-red-400 text-sm animate-pulse" /> Download MoM PDF Document
                </a>
              ) : <div />}

              <button
                onClick={() => {
                  setSelectedEventModal(null);
                  const el = document.getElementById('visitor_reg_btn');
                  if (el) el.click();
                }}
                className="px-5 py-2.5 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] font-black text-xs rounded-xl shadow-lg flex items-center gap-2 transition cursor-pointer"
              >
                <FaTicketAlt /> Attend Event Now
              </button>
            </div>

          </div>
        </div>
      )}
      
      {/* Latest News & Events */}
      <div className="bg-[#1E2A3A] py-16 px-[8%] border-b border-[#465468]/60">
        <div className="flex flex-wrap w-[100%]">
          <div className=" sm:w-[50%]">
            <p className="text-[#F1F4F9] text-[16px] font-normal leading-5 mb-4">
              OUR NEWS / EVENTS
            </p>
            <span className="text-[#F1F4F9] text-[39px] leading-10	font-bold	">
              Learn About Our
            </span>
            <span className="text-[39px] leading-10	font-bold	text-[#FDBC12] ml-2">
              Latest News
            </span>
          </div>
          <div className="  sm:w-[50%] md:flex justify-end items-center sm:mt-0 mt-4">
            <Link to="/blogs">
              <button className="bg-[#02256D] w-[150px] py-3 rounded text-[#F1F4F9] text-[16px] font-normal">
                View All
              </button>
            </Link>
          </div>
        </div>
        {/* News boxs */}
        <BlogList limit={3} />
      </div>

      {/* 6. RMBIANS OF MEETING & BIRTHDAYS IN THIS MONTH SECTION (#6 Position on Homepage) */}
      <Birthday />

      {/* 7. Why Join Us Section */}
      <div
        className="bg-cover bg-center relative px-[8%] py-[80px] w-full flex flex-wrap items-center overflow-hidden"
        style={{ backgroundImage: `url(${Whyjoinbg})` }}
      >
        <div className="absolute inset-0 bg-[#070D18]/90 backdrop-blur-xs"></div>
        <div className="relative z-10 lg:w-[60%] w-full">
          <div className="inline-block bg-[#FDBC12]/15 text-[#FDBC12] text-xs font-extrabold uppercase px-3.5 py-1 rounded-full border border-[#FDBC12]/30 mb-3 tracking-widest">
            Membership Benefits
          </div>
          <h2 className="text-[#F1F4F9] text-[36px] md:text-[44px] font-black leading-tight">
            Why You Must Join <span className="text-[#FDBC12]">RMB Jaipur</span>
          </h2>
          <div className="mt-8 space-y-6 max-w-2xl">
            <div className="flex gap-4">
              <span className="text-[#FDBC12] font-black text-2xl bg-[#0A1527] border border-[#FDBC12]/40 rounded-xl px-3 py-1 self-start shadow-md">01</span>
              <div>
                <h3 className="text-[18px] font-bold text-[#F1F4F9] mb-1">Trusted Rotarian Network</h3>
                <p className="text-[#94A2B8] text-[14px] leading-relaxed">
                  RMB brings together a community of Rotarians with shared values of service, integrity, and ethics, creating a trustworthy, high-integrity business environment.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <span className="text-[#FDBC12] font-black text-2xl bg-[#0A1527] border border-[#FDBC12]/40 rounded-xl px-3 py-1 self-start shadow-md">02</span>
              <div>
                <h3 className="text-[18px] font-bold text-[#F1F4F9] mb-1">Accelerated Professional Growth</h3>
                <p className="text-[#94A2B8] text-[14px] leading-relaxed">
                  We offer high-value business networking, structured referral exchanges, and knowledge-sharing opportunities to scale your enterprise alongside top industry leaders.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <span className="text-[#FDBC12] font-black text-2xl bg-[#0A1527] border border-[#FDBC12]/40 rounded-xl px-3 py-1 self-start shadow-md">03</span>
              <div>
                <h3 className="text-[18px] font-bold text-[#F1F4F9] mb-1">Impactful Community Service</h3>
                <p className="text-[#94A2B8] text-[14px] leading-relaxed">
                  RMB members actively contribute to humanitarian initiatives while building meaningful business relationships, aligning commercial success with fellowship.
                </p>
              </div>
            </div>
            
            <a href="/about" className="inline-block mt-4">
              <button className="bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] px-8 py-3 rounded-xl font-bold text-[15px] shadow-lg transition-all duration-300 hover:scale-105 active:scale-95 cursor-pointer">
                Discover More Benefits →
              </button>
            </a>
          </div>
        </div>
        <div className="lg:w-[40%] w-full relative z-10 flex lg:justify-end justify-center mt-10 lg:mt-0">
          <img className="max-h-[480px] object-contain rounded-2xl drop-shadow-2xl" src={ManImage} alt="Join RMB Jaipur" />
        </div>
      </div>

      {/* 8. Welcome & Chapter Vision Section */}
      <div className="bg-[#1E2A3A] px-[8%] py-[80px] border-y border-[#465468]/60">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-[34px] md:text-[42px] text-[#F1F4F9] font-black leading-tight mb-4">
            Welcome to <br />
            <span className="text-[#FDBC12]"> Rotary Means Business </span> (RMB) Fellowship Jaipur
          </h2>
          <p className="text-[#CBD5E0] text-[16px] md:text-[18px] leading-relaxed max-w-3xl mx-auto">
            Rotary Means Business encourages Rotarians and Non-Rotarians to support the success of fellow members by doing business directly and extending quality business referrals.
          </p>
        </div>

        <div className="bg-gradient-to-r from-[#02256D]/80 to-[#0A1A3F]/80 border border-[#FDBC12]/70 p-8 md:p-10 rounded-2xl max-w-4xl mx-auto mb-12 shadow-2xl backdrop-blur-md">
          <h3 className="text-center text-[26px] md:text-[30px] text-[#FDBC12] font-black mb-3 tracking-wide">
            🎯 Vision of the Chapter
          </h3>
          <p className="text-[#E1E8F0] text-[16px] md:text-[17px] text-center leading-relaxed font-medium">
            At Rotary Means Business Jaipur, our vision is to foster a vibrant, ethical community of business leaders committed to integrity, collaboration, and Service Above Self. We believe that true business success creates lasting positive transformation in society.
          </p>
        </div>

        <div className="max-w-5xl mx-auto overflow-hidden rounded-2xl border border-[#465468] shadow-2xl">
          <img
            className="w-full sm:h-[480px] h-[280px] object-cover hover:scale-102 transition duration-500"
            src={welcomeimage}
            alt="RMB Fellowship Jaipur Team"
          />
        </div>
      </div>

      {/* Chapter Teams Component */}
      <Teams />

      {/* RMB NEWS & MEDIA HIGHLIGHTS SECTION */}
      {newsMediaList.length > 0 && (
        <div className="bg-[#070D18] py-20 px-[8%] border-b border-[#465468]/60">
          <div className="max-w-7xl mx-auto space-y-10">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 border-b border-slate-800 pb-6">
              <div>
                <div className="inline-block bg-[#FDBC12]/15 text-[#FDBC12] text-xs font-extrabold uppercase px-3.5 py-1 rounded-full border border-[#FDBC12]/30 mb-2 tracking-widest">
                  📰 Press & Media Room
                </div>
                <h2 className="text-[32px] md:text-[40px] text-[#F1F4F9] font-black tracking-wide leading-tight">
                  RMB News & <span className="text-[#FDBC12]">Media Highlights</span>
                </h2>
                <p className="text-xs md:text-sm text-[#94A2B8] mt-1 font-semibold">
                  Media publications, press releases, and national news coverage of Rotary Means Business Jaipur.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {newsMediaList.slice(0, 3).map((item: any) => (
                <div
                  key={item.id}
                  onClick={() => setSelectedNewsArticle(item)}
                  className="bg-[#131E32] rounded-2xl border border-[#2A3B5C] hover:border-[#FDBC12] overflow-hidden flex flex-col justify-between shadow-2xl transition duration-300 hover:-translate-y-1 cursor-pointer group"
                >
                  {item.image ? (
                    <img
                      src={item.image.startsWith('http') ? item.image : `https://rmbbackend.rmbjaipur.com/${item.image.replace(/^\//, '')}`}
                      alt={item.title}
                      className="h-48 w-full object-cover group-hover:scale-105 transition duration-500"
                      onError={(e) => { e.currentTarget.src = 'https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg'; }}
                    />
                  ) : (
                    <div className="h-48 w-full bg-slate-900 flex items-center justify-center text-slate-500 font-bold text-xs">
                      RMB Media Coverage
                    </div>
                  )}

                  <div className="p-5 space-y-3 flex-1 flex flex-col justify-between">
                    <div className="space-y-2">
                      <div className="flex justify-between items-center text-xs font-bold text-[#FDBC12]">
                        <span className="bg-[#0A2451] px-2.5 py-0.5 rounded-full border border-[#FDBC12]/40 text-[10px]">{item.category || 'Media Coverage'}</span>
                        <span className="text-slate-400 text-[11px]">{item.date}</span>
                      </div>
                      <h3 className="font-bold text-white text-base leading-snug line-clamp-2 group-hover:text-[#FDBC12] transition">{item.title}</h3>
                      <p className="text-slate-300 text-xs leading-relaxed line-clamp-3">{item.summary}</p>
                    </div>

                    <div className="pt-3 border-t border-[#2A3B5C]">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedNewsArticle(item);
                        }}
                        className="inline-flex items-center gap-1.5 text-xs font-bold text-[#FDBC12] hover:text-amber-300 transition cursor-pointer"
                      >
                        Read Media Release <FaExternalLinkAlt size={11} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* FULL NEWS & MEDIA RELEASE ARTICLE DETAIL MODAL */}
      {selectedNewsArticle && (
        <div 
          className="fixed inset-0 bg-black/75 backdrop-blur-md flex items-center justify-center z-50 p-4 animate-fade-in"
          onClick={() => setSelectedNewsArticle(null)}
        >
          <div 
            className="bg-[#131E32] rounded-3xl border border-[#2A3B5C] shadow-2xl max-w-2xl w-full overflow-hidden text-slate-100 relative max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header Bar */}
            <div className="p-5 bg-[#0D1525] border-b border-[#2A3B5C] flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="bg-[#FDBC12] text-[#0A2451] font-black text-[10px] uppercase px-3 py-1 rounded-full">
                  {selectedNewsArticle.category || 'Media Coverage'}
                </span>
                <span className="text-xs text-slate-400 font-bold">{selectedNewsArticle.date}</span>
              </div>
              <button
                type="button"
                onClick={() => setSelectedNewsArticle(null)}
                className="w-8 h-8 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white flex items-center justify-center font-bold text-sm transition cursor-pointer"
              >
                ✕
              </button>
            </div>

            {/* Modal Scrollable Content */}
            <div className="p-6 overflow-y-auto space-y-4">
              {selectedNewsArticle.image && (
                <img
                  src={selectedNewsArticle.image.startsWith('http') ? selectedNewsArticle.image : `https://rmbbackend.rmbjaipur.com/${selectedNewsArticle.image.replace(/^\//, '')}`}
                  alt={selectedNewsArticle.title}
                  className="w-full h-64 object-cover rounded-2xl border border-[#2A3B5C] shadow-lg"
                  onError={(e) => { e.currentTarget.src = 'https://rmbbackend.rmbjaipur.com/uploads/default_news.jpg'; }}
                />
              )}

              <h2 className="text-xl sm:text-2xl font-black text-white leading-snug">
                {selectedNewsArticle.title}
              </h2>

              <div className="text-sm text-slate-300 leading-relaxed whitespace-pre-line border-t border-[#2A3B5C]/60 pt-3">
                {selectedNewsArticle.summary || 'No summary details provided for this news release.'}
              </div>
            </div>

            {/* Modal Footer Bar */}
            <div className="p-4 bg-[#0D1525] border-t border-[#2A3B5C] flex items-center justify-between">
              {selectedNewsArticle.source_link ? (
                <a
                  href={selectedNewsArticle.source_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-2 bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-[#0A2451] font-black text-xs rounded-xl shadow-lg flex items-center gap-1.5 transition cursor-pointer"
                >
                  <span>View External Press Link</span>
                  <FaExternalLinkAlt size={11} />
                </a>
              ) : (
                <span className="text-xs text-slate-400 font-bold">RMB Jaipur Official Publication</span>
              )}

              <button
                type="button"
                onClick={() => setSelectedNewsArticle(null)}
                className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 font-extrabold text-xs rounded-xl cursor-pointer"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Member Testimonials Section */}
      <div className="bg-[#0D1525] py-20 px-[8%] border-b border-[#465468]/60">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <div className="inline-block bg-[#FDBC12]/15 text-[#FDBC12] text-xs font-extrabold uppercase px-3.5 py-1 rounded-full border border-[#FDBC12]/30 mb-3 tracking-widest">
            Member Endorsements & Feedback
          </div>
          <h2 className="text-[34px] md:text-[42px] text-[#F1F4F9] font-black leading-tight">
            What Our <span className="text-[#FDBC12]">RMB Members</span> Say
          </h2>
          <p className="text-[#94A2B8] text-[15px] md:text-[16px] leading-relaxed max-w-2xl mx-auto mt-2">
            Hear directly from business leaders and Rotarians about how Rotary Means Business Fellowship Jaipur has transformed their business growth and professional network.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Testomonail />
        </div>
      </div>

      {/* Call To Action Banner */}
      <div
        className="px-[8%] py-[80px] bg-cover bg-center relative flex flex-wrap items-center justify-between border-y border-[#465468]/60 overflow-hidden"
        style={{ backgroundImage: `url(${connectNowbg})` }}
      >
        <div className="absolute inset-0 bg-[#02256D]/90 backdrop-blur-xs"></div>
        <div className="relative z-10 text-[#F1F4F9] max-w-2xl">
          <h2 className="text-[30px] md:text-[38px] font-black leading-tight">
            Become part of a global network dedicated to <br />
            <span className="text-[#FDBC12]">mutual success, business growth, & service.</span>
          </h2>
        </div>
        <a href="/contact" className="relative z-20 mt-6 lg:mt-0">
          <button className="bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] px-8 py-3.5 rounded-xl font-bold text-[16px] shadow-2xl transition-all duration-300 hover:scale-105 active:scale-95 cursor-pointer">
            Connect Now →
          </button>
        </a>
      </div>

      {/* Impact Stats Counter Section */}
      <div
        className="px-[8%] py-[80px] bg-cover bg-center relative flex flex-wrap items-center justify-between w-full gap-y-6"
        style={{ backgroundImage: `url(${counterbg})` }}
      >
        <div className="absolute inset-0 bg-[#070A13]/90 backdrop-blur-xs"></div>
        
        <div className="bg-[#101729]/90 border border-[#465468] p-6 relative z-10 flex flex-col lg:w-[23%] sm:w-[48%] w-full items-center rounded-2xl h-[220px] justify-center hover:border-[#FDBC12] hover:-translate-y-1 transition duration-300 shadow-xl">
          <img className="w-[64px] mb-3" src={countericon1} alt="Worldwide Chapters" />
          <h2 className="text-[#FDBC12] text-[36px] font-black">200+</h2>
          <p className="text-[#E1E8F0] text-[14px] text-center font-semibold mt-1">Chapters Worldwide</p>
        </div>

        <div className="bg-[#101729]/90 border border-[#465468] p-6 relative z-10 flex flex-col lg:w-[23%] sm:w-[48%] w-full items-center rounded-2xl h-[220px] justify-center hover:border-[#FDBC12] hover:-translate-y-1 transition duration-300 shadow-xl">
          <img className="w-[64px] mb-3" src={countericon2} alt="Chapters in India" />
          <h2 className="text-[#FDBC12] text-[36px] font-black">80+</h2>
          <p className="text-[#E1E8F0] text-[14px] text-center font-semibold mt-1">Chapters in India</p>
        </div>

        <div className="bg-[#101729]/90 border border-[#465468] p-6 relative z-10 flex flex-col lg:w-[23%] sm:w-[48%] w-full items-center rounded-2xl h-[220px] justify-center hover:border-[#FDBC12] hover:-translate-y-1 transition duration-300 shadow-xl">
          <img className="w-[64px] mb-3" src={countericon3} alt="Annual Meetings" />
          <h2 className="text-[#FDBC12] text-[36px] font-black">24+</h2>
          <p className="text-[#E1E8F0] text-[14px] text-center font-semibold mt-1">Annual Meetings</p>
        </div>

        <div className="bg-[#101729]/90 border border-[#465468] p-6 relative z-10 flex flex-col lg:w-[23%] sm:w-[48%] w-full items-center rounded-2xl h-[220px] justify-center hover:border-[#FDBC12] hover:-translate-y-1 transition duration-300 shadow-xl">
          <img className="w-[64px] mb-3" src={countericon4} alt="Closed Business" />
          <h2 className="text-[#FDBC12] text-[36px] font-black">₹10Cr+</h2>
        </div>
      </div>

      {/* FEATURED CHAPTER VIDEO SHOWCASE SECTION (Moved to the end of the page before Footer) */}
      {featuredVideo && featuredVideo.video_url && (
        <div className="bg-[#070D18] py-16 px-[8%] border-t border-b border-[#465468]/60">
          <div className="max-w-5xl mx-auto text-center space-y-6">
            <div className="inline-block bg-[#FDBC12]/15 text-[#FDBC12] text-xs font-extrabold uppercase px-3.5 py-1 rounded-full border border-[#FDBC12]/30 tracking-widest shadow-md">
              🎬 Featured Chapter Video
            </div>
            <h2 className="text-[32px] md:text-[40px] text-[#F1F4F9] font-black leading-tight">
              {featuredVideo.title || "Discover Rotary Means Business Fellowship Jaipur"}
            </h2>
            {featuredVideo.description && (
              <p className="text-[#94A2B8] text-[15px] max-w-2xl mx-auto leading-relaxed font-medium">
                {featuredVideo.description}
              </p>
            )}

            <div className="relative aspect-video max-w-4xl mx-auto rounded-2xl overflow-hidden border-2 border-[#FDBC12]/50 shadow-2xl bg-black">
              <iframe
                src={featuredVideo.video_url.includes('watch?v=') ? featuredVideo.video_url.replace('watch?v=', 'embed/') : featuredVideo.video_url}
                title={featuredVideo.title || 'RMB Jaipur Featured Video'}
                className="w-full h-full border-0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}

      <Footer />

      {/* Birthday Celebration Popup Modal */}
      {showBirthdayModal && todayBirthdayMember && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md p-4 animate-fade-in">
          <div className="bg-gradient-to-b from-[#0F1C36] via-[#0A1428] to-[#070D18] border-2 border-[#FDBC12] rounded-3xl p-6 sm:p-8 max-w-md w-full text-center relative shadow-2xl overflow-hidden">
            
            {/* Confetti & Balloon Decorative Elements */}
            <div className="absolute top-3 left-4 text-3xl animate-bounce">🎈</div>
            <div className="absolute top-3 right-12 text-2xl">✨</div>
            <div className="absolute bottom-4 left-4 text-2xl">🎉</div>
            <div className="absolute bottom-3 right-4 text-3xl">🥳</div>

            {/* Close Button */}
            <button
              onClick={() => {
                setShowBirthdayModal(false);
                sessionStorage.setItem('birthdayModalDismissed', 'true');
              }}
              className="absolute top-4 right-4 w-8 h-8 rounded-full bg-slate-800/80 hover:bg-slate-700 text-slate-300 flex items-center justify-center text-sm font-bold cursor-pointer transition"
            >
              ✕
            </button>

            {/* Header Badge */}
            <div className="inline-block bg-[#FDBC12]/20 text-[#FDBC12] border border-[#FDBC12]/40 text-xs font-black uppercase px-4 py-1.5 rounded-full mb-4 tracking-widest">
              🎂 Today's Birthday Celebration 🎉
            </div>

            {/* Member Profile Avatar with Glowing Ring */}
            <div className="relative w-28 h-28 mx-auto mb-4">
              <div className="w-28 h-28 rounded-full border-4 border-[#FDBC12] overflow-hidden shadow-xl shadow-amber-500/20 bg-slate-950">
                <img
                  src={todayBirthdayMember.profile ? (todayBirthdayMember.profile.startsWith('http') ? todayBirthdayMember.profile : `https://rmbbackend.rmbjaipur.com/${todayBirthdayMember.profile.replace(/^\//, '')}`) : 'https://via.placeholder.com/150'}
                  alt={todayBirthdayMember.name}
                  className="w-full h-full object-cover"
                  onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/150?text=Member'; }}
                />
              </div>
              <div className="absolute -bottom-2 -right-1 bg-[#FDBC12] text-[#0A2451] p-1.5 rounded-full text-base shadow-lg">
                🎁
              </div>
            </div>

            {/* Greeting Messages */}
            <h3 className="text-2xl font-black text-white tracking-wide">
              Happy Birthday!
            </h3>
            <h4 className="text-xl font-extrabold text-[#FDBC12] mt-1">
              {todayBirthdayMember.name}
            </h4>
            <p className="text-xs font-semibold text-slate-300 mt-1">
              {todayBirthdayMember.company_name || todayBirthdayMember.designation || 'Rotary Means Business Jaipur Member'}
            </p>

            <p className="text-slate-300 text-xs leading-relaxed mt-4 bg-slate-900/80 p-3.5 rounded-xl border border-slate-800">
              "On behalf of Rotary Means Business Fellowship Jaipur, we wish you a fantastic birthday filled with joy, happiness, and extraordinary business success!" 🌟
            </p>

            {/* Action Buttons */}
            <div className="mt-6 flex flex-col sm:flex-row items-center gap-3">
              <a
                href={`https://wa.me/${todayBirthdayMember.mobile || ''}?text=${encodeURIComponent(`Happy Birthday ${todayBirthdayMember.name}! 🎂🎉 Warm wishes from Rotary Means Business Jaipur!`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-3 bg-emerald-600 hover:bg-emerald-500 text-white font-black text-xs rounded-xl shadow-lg flex items-center justify-center gap-2 cursor-pointer transition"
              >
                <FaWhatsapp size={16} /> Wish Happy Birthday on WhatsApp
              </a>

              <button
                onClick={() => {
                  setShowBirthdayModal(false);
                  sessionStorage.setItem('birthdayModalDismissed', 'true');
                }}
                className="w-full sm:w-auto px-5 py-3 bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold text-xs rounded-xl cursor-pointer transition border border-slate-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Homes;
